/*
 * File: /src/stores/shop-products-edit.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 20th July 2018 2:20:53 pm
 * Last Modified: Friday, 24th August 2018 11:20:53 am
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
import { StoreDefaultMetafieldsHelper } from '@/helpers'

const initialState = () => ({
    scope: 'customobjects',
    key: null,
})

const state = StoreDefaultMetafieldsHelper.buildState({ 
    state: initialState()
})


const actions = StoreDefaultMetafieldsHelper.buildActions({
    actions: {}
})

const mutations = StoreDefaultMetafieldsHelper.buildMutations({
    mutations: {
        SET_KEY(state, { key }) {
            state.key = key
        }
    }
})

const getters = StoreDefaultMetafieldsHelper.buildGetters({
    getters: {}
})

export default {
    namespaced: true,
    state, actions, mutations, getters
}


// WEBPACK FOOTER //
// ./src/stores/shop-customobjects-edit.js